import { createSelector } from '@ngrx/store';
import {
  FilePrice,
  PriceToAddToEveryFileInProduct,
  PriceToAddToFirstPrint,
  PrintPrice,
  RetouchLevel,
  ShoppingCartState,
} from './standalone';

const selectFeature = (state: { shoppingCart: ShoppingCartState }) =>
  state.shoppingCart;

export const selectProductsInBasket = createSelector(
  selectFeature,
  (state: ShoppingCartState) => state.productInBasket,
);
export const selectProductsList = createSelector(
  selectFeature,
  (state: ShoppingCartState) => state.products,
);
export const selectAllCost = createSelector(
  selectFeature,
  (state: ShoppingCartState) => state.cost,
);
export const selectFreePackage = createSelector(
  selectFeature,
  (state: ShoppingCartState) => state.freePackage,
);
export const selectRetouchLevels = createSelector(
  selectFeature,
  (state: ShoppingCartState) => state.retouchLevels,
);
export const selectMenuOfLovedPhotos = createSelector(
  selectFeature,
  (state: ShoppingCartState) => state.menuOfLovedPhotos,
);
export const selectProductVouchers = createSelector(
  selectFeature,
  (state: ShoppingCartState) => state.productVouchers,
);
export const selectCalcPrintsInPackage = createSelector(
  selectFeature,
  (state: ShoppingCartState) => state.calcPrintsInPackage,
);
export const selectDisplayImagesStyles = createSelector(
  selectFeature,
  (state: ShoppingCartState) => state.displayImagesStyles,
);
export const selectMinimumOrderValueConfig = createSelector(
  selectFeature,
  (state: ShoppingCartState) => state.orderMinimumValueConfig,
);
export const selectBasketStyle = createSelector(
  selectFeature,
  (state: ShoppingCartState) => state.basketStyle,
);
export const selectDeliveryMethodChosenByClient = createSelector(
  selectFeature,
  (state: ShoppingCartState) => state.deliveryMethodChosenByClient,
);
export const selectShoppingCartId = createSelector(
  selectFeature,
  (state: ShoppingCartState) => state.shoppingCartId,
);
export const selectDeliveryMethods = createSelector(
  selectFeature,
  (state: ShoppingCartState) => state.deliveryMethods,
);
export const selectPrintsInBasket = createSelector(
  selectFeature,
  (state: ShoppingCartState) => state.printInBasket,
);
export const selectTabloInBasket = createSelector(
  selectFeature,
  (state: ShoppingCartState, props: { tabloId: string }) =>
    state.tabloInBasket.find((t) => t.tabloForDisplayId === props?.tabloId),
);
export const selectAllTabloInBasket = createSelector(
  selectFeature,
  (state: ShoppingCartState) => state.tabloInBasket.filter((v) => v.count),
);
export const selectCalendarInBasket = createSelector(
  selectFeature,
  (state: ShoppingCartState, props: { photoId: string }) =>
    state.calendarInBasket.find((t) => t.photoId === props?.photoId),
);
export const selectAllCalendarInBasket = createSelector(
  selectFeature,
  (state: ShoppingCartState) => state.calendarInBasket.filter((v) => v.count),
);
export const selectMagnetInBasket = createSelector(
  selectFeature,
  (state: ShoppingCartState, props: { photoId: string; size: string }) =>
    state.magnetInBasket.find(
      (item) => item.photoId === props?.photoId && item.size === props?.size,
    ),
);
export const selectAllMagnetInBasket = createSelector(
  selectFeature,
  (state: ShoppingCartState) => state.magnetInBasket.filter((v) => v.count),
);
export const selectPrintPrices = createSelector(
  selectFeature,
  (state: ShoppingCartState) => state.printPrice,
);
export const selectTabloPrices = createSelector(
  selectFeature,
  (state: ShoppingCartState) => state.tabloPricing,
);
export const selectPrintVouchers = createSelector(
  selectFeature,
  (state: ShoppingCartState) => state.printVoucher,
);
export const selectAllProductsInBasket = createSelector(
  selectFeature,
  (state: ShoppingCartState) => state.allProductsInBasket,
);
export const selectPriceToAddToEveryFileInProduct = createSelector(
  selectFeature,
  (state: ShoppingCartState) =>
    state?.priceToAddToEveryFileInProduct ?? {
      addPriceToEveryFileInProduct: false,
      addEveryFileToBasketIfNotAlreadyBought: false,
      countWithFilePrices: false,
      price: [],
      skipAddToEveryFileInProductIfFileBought: false,
    },
);
export const selectPriceToAddToEveryFileInLookBookProduct = createSelector(
  selectFeature,
  (state: ShoppingCartState) =>
    state?.priceToAddToEveryFileInLookBookProduct ?? {
      addPriceToEveryFileInProduct: false,
      addEveryFileToBasketIfNotAlreadyBought: false,
      countWithFilePrices: false,
      price: [],
      skipAddToEveryFileInProductIfFileBought: false,
    },
);
export const selectPhotosList = createSelector(
  selectFeature,
  (state: ShoppingCartState) => state.photoGroupList,
);
export const selectCustomDigitalFileName = createSelector(
  selectFeature,
  (state: ShoppingCartState) => state.customDigitalFileName,
);
export const selectLoadedFileData = createSelector(
  selectFeature,
  (state: ShoppingCartState) => state.loadedFileData,
);
export const selectUsePromoCodes = createSelector(
  selectFeature,
  (state: ShoppingCartState) => state.usePromoCodes,
);
export const selectLoadedPrintData = createSelector(
  selectFeature,
  (state: ShoppingCartState) => state.loadedPrintData,
);
export const selectConfigSell = createSelector(
  selectFeature,
  (state: ShoppingCartState) => state.configSell,
);
export const selectLoadedProductData = createSelector(
  selectFeature,
  (state: ShoppingCartState) => state.loadedProductData,
);
export const selectLoadedPackageData = createSelector(
  selectFeature,
  (state: ShoppingCartState) => state.loadedPackageData,
);
export const selectLoadedPromoCodeData = createSelector(
  selectFeature,
  (state: ShoppingCartState) => state.loadedPromoCodeData,
);
export const selectLoadedData = createSelector(
  selectFeature,
  (state: ShoppingCartState) => state.loadedData,
);
export const selectFavList = createSelector(
  selectFeature,
  (state: ShoppingCartState) => state.favList,
);
export const selectOnyFavImages = createSelector(
  selectFeature,
  (state: ShoppingCartState) => state.onyFavImages,
);
export const selectDoNotAddPriceOfFirstPrint = createSelector(
  selectFeature,
  (state: ShoppingCartState) => state.doNotAddPriceOfFirstPrint,
);
export const selectSizeFile = createSelector(
  selectFeature,
  (state: ShoppingCartState) => state.fileSize,
);
export const selectPhotoGroupsHasPhoto = createSelector(
  selectFeature,
  (state: ShoppingCartState) => state.photoGroupHasPhoto,
);
export const selectFilesInBasket = createSelector(
  selectFeature,
  (state: ShoppingCartState) => state.fileInBasket,
);
export const selectLookBookProductsInBasket = createSelector(
  selectFeature,
  (state: ShoppingCartState) => state.lookBookProductInBasket,
);
export const selectLookBookProductConfig = (lookBookProductConfigId) =>
  createSelector(selectFeature, (state: ShoppingCartState) =>
    state.lookBookProductInBasket.find(
      (product) => product.lookBookProductConfigId === lookBookProductConfigId,
    ),
  );
export const selectPhotoGroups = createSelector(
  selectFeature,
  (state: ShoppingCartState) => state.photoGroup,
);
export const selectFilePrices = createSelector(
  selectFeature,
  (state: ShoppingCartState) => state.filePrice,
);
export const selectFileVouchers = createSelector(
  selectFeature,
  (state: ShoppingCartState) => state.groupFileVouchers,
);
export const selectOwnPhotosCost = createSelector(
  selectFeature,
  (state: ShoppingCartState) => state.ownPhotosCost,
);
export const selectPackagesInShop = createSelector(
  selectFeature,
  (state: ShoppingCartState) => state.packages,
);
export const selectPackagesInBasket = createSelector(
  selectFeature,
  (state: ShoppingCartState) => state.packageInBasket,
);
export const selectMandatoryPackageAtTheBeginning = createSelector(
  selectFeature,
  (state: ShoppingCartState) => state.mandatoryPackageAtTheBeginning,
);
export const selectWasProposedPackageWithPhotos = createSelector(
  selectFeature,
  (state: ShoppingCartState) => state.wasProposedPackageWithPhotos,
);
export const selectPriceToAddToFirstPrint = createSelector(
  selectFeature,
  (state: ShoppingCartState) => state.priceToAddToFirstPrint,
);
export const selectShoppingCartContext = createSelector(
  selectFeature,
  (state: ShoppingCartState) => state.context,
);
export const selectShoppingCartOrderNumber = createSelector(
  selectFeature,
  (state: ShoppingCartState) => state.orderNumber,
);
export const selectForcePhoneForDigitalOnly = createSelector(
  selectFeature,
  (state: ShoppingCartState) => state.digitalOrderForcePhone,
);
export const selectShoppingCartOrderHash = createSelector(
  selectFeature,
  (state: ShoppingCartState) => state.hash,
);
export const selectShoppingCartOrderAuthToken = createSelector(
  selectFeature,
  (state: ShoppingCartState) => state.orderAuthToken,
);
export const selectSkipFavoriteInFileMode = createSelector(
  selectFeature,
  (state: ShoppingCartState) => state.skipFavoriteInFileMode,
);
export const selectShoppingCartPromoCode = createSelector(
  selectFeature,
  (state: ShoppingCartState) => state.promoCode,
);
export const selectSettingPhotoGroup = createSelector(
  selectFeature,
  (state: ShoppingCartState) => {
    return state.photoGroup.map(({ photoGroupId, config }) => {
      const selectedPricing: {
        filesPricing: Array<FilePrice>;
        printsPricing: Array<PrintPrice>;
        retouchLevels: Array<RetouchLevel>;
        selectedProducts: Array<string>;
        globalSellPrints: boolean;
      } = {
        filesPricing: [],
        printsPricing: [],
        retouchLevels: [],
        selectedProducts: [],
        globalSellPrints: false,
      };
      const settings: {
        products: PriceToAddToEveryFileInProduct & { sellProducts: boolean };
        files: {
          sellFiles: boolean;
        };
        prints: PriceToAddToFirstPrint & {
          sellPrints: boolean;
        };
        packages: { sellPackages: boolean };
      } = {
        products: {
          sellProducts: false,
          price: [],
          addPriceToEveryFileInProduct: false,
          skipAddToEveryFileInProductIfFileBought: false,
          addEveryFileToBasketIfNotAlreadyBought: false,
          countWithFilePrices: false,
        },
        files: {
          sellFiles: false,
        },
        prints: {
          sellPrints: false,
          priceToAddToFirstPrint: [],
          addToFirstPrintPrice: false,
          skipAddToFirstPrintIfFileBought: false,
          addPrintFileToBasketIfNotAlreadyBought: false,
          countWithFilePrices: false,
        },
        packages: { sellPackages: false },
      };
      settings.packages.sellPackages = state.configSell.sellPackages;
      if (config?.individualSellSettings) {
        if (config.sellPrints) {
          settings.prints = {
            sellPrints: true,
            ...config.priceToAddToFirstPrint,
          };
          if (config.customPrintsPricing) {
            selectedPricing.printsPricing = config.prints;
          } else {
            selectedPricing.printsPricing = state.printPrice;
            selectedPricing.globalSellPrints = true;
          }
        }
        if (config.sellFiles) {
          settings.files = {
            sellFiles: true,
          };
          if (config.customFilesPricing) {
            selectedPricing.filesPricing = config.files;
            /**
             * trzeba dodać retusz w grupach
             */
            selectedPricing.retouchLevels = [];
          } else {
            selectedPricing.filesPricing = state.filePrice;
            selectedPricing.retouchLevels = state.retouchLevels;
          }
        }
        if (config.sellProducts) {
          settings.products = {
            sellProducts: true,
            ...(config.customProductsConfig
              ? config.priceToAddToEveryFileInProduct
              : state.priceToAddToEveryFileInProduct),
          };
          if (config.customProductsConfig) {
            selectedPricing.selectedProducts = state.products
              .filter(
                ({ productId }) =>
                  !config.excludedProducts?.includes(productId),
              )
              .map(({ productId }) => productId);
          } else {
            selectedPricing.selectedProducts = state.products
              .filter(
                ({ productId }) =>
                  !state.configSell.excludedProducts?.includes(productId),
              )
              .map(({ productId }) => productId);
          }
        }
      } else {
        if (state.configSell.sellPrints) {
          settings.prints = {
            sellPrints: true,
            ...state.priceToAddToFirstPrint,
          };
          selectedPricing.printsPricing = state.printPrice;
          selectedPricing.globalSellPrints = true;
        }
        if (state.configSell.sellFiles) {
          settings.files = {
            sellFiles: true,
          };
          selectedPricing.filesPricing = state.filePrice;
          selectedPricing.retouchLevels = state.retouchLevels;
        }
        if (state.configSell.sellProducts) {
          settings.products = {
            sellProducts: true,
            ...state.priceToAddToEveryFileInProduct,
          };
          selectedPricing.selectedProducts = state.products
            .filter(
              ({ productId }) =>
                !state.configSell.excludedProducts?.includes(productId),
            )
            .map(({ productId }) => productId);
        }
      }
      return { photoGroupId, selectedPricing, settings };
    });
  },
);

export const selectGetPrintsPricingForPhoto = createSelector(
  selectFeature,
  (state: ShoppingCartState, props: { photoId: string }) => {
    console.log('SELECTING PRINT PRICING FOR ');
    let photoGroup = '';
    state.photoGroupList.find(
      ({ photos }) =>
        (photoGroup = photos.find(
          ({ photoId }) => photoId === props.photoId,
        )?.photoGroupId),
    );
    const groupConfig = state.photoGroup.find(
      ({ photoGroupId }) => photoGroupId === photoGroup,
    );
    if (groupConfig && groupConfig.config.individualSellSettings) {
      return groupConfig.config;
    }
    return {
      prints: state.printPrice,
      sellPrints: null,
      customFilesPricing: null,
      customPrintsPricing: null,
      individualSellSettings: null,
      priceToAddToFirstPrint: {
        addToFirstPrintPrice: null,
        skipAddToFirstPrintIfFileBought: null,
        addPrintFileToBasketIfNotAlreadyBought: null,
        priceToAddToFirstPrint: [],
      },
      sellFiles: null,
      files: state.filePrice,
      customProductsConfig: null,
      sellProducts: null,
      disableLookBook: groupConfig?.config?.disableLookBook ?? false,
      disableZalamoPrint: groupConfig?.config?.disableZalamoPrint ?? false,
    };
  },
);

export const selectPrintFrameCount = (photoId, value) => {
  const index = JSON.stringify(value);
  return createSelector(
    selectFeature,
    (state: ShoppingCartState) =>
      state.printFrames.find((p) => p.photoId === photoId && p.value === index)
        ?.count,
  );
};
export const selectPrintFramesInBasket = createSelector(
  selectFeature,
  (state: ShoppingCartState) => state.printFrames,
);

export const selectPhotoById = (photoId) =>
  createSelector(selectFeature, (state: ShoppingCartState) =>
    state.photoGroupList[
      state.photoGroup.findIndex(
        (g) =>
          g.config.publicSessionGroupId ===
          state.photoGroupHasPhoto.find((pghp) => pghp.photoId === photoId)
            ?.photoGroupId,
      )
    ].photos.find((p) => p.photoId === photoId),
  );
